import { Progress } from '../'
import React from 'react'
import styles from './index.module.css'

type Props = React.ComponentProps<typeof Progress> & {
  value?: number | 0
}

/**
 * Loading progress bar component positioned at the top of the viewport.
 *
 * Extends Radix UI Progress with fixed positioning for page-level loading indicators.
 * Automatically positions itself below banners using CSS data attributes.
 *
 * @param value - Number between 0-1 indicating progress completion
 * @see https://www.radix-ui.com/themes/docs/components/progress - Radix UI Progress documentation
 */
const ProgressBarLoader = ({ value = 0 }: Props): React.ReactNode => {
  // Accent color is used as default for the progress bar
  return (
    <Progress
      className={styles.progressBarLoader}
      size="3"
      variant="soft"
      radius="none"
      value={value}
    />
  )
}

export default ProgressBarLoader
